import React, {useMemo}  from 'react'
import { NavLink } from 'react-router-dom'
import { useUsersSettings } from './UsersSettingsContext'
import { useAuth } from '../../Contexts/AuthProvider'
import MyIcons from '../../assets/img/Icons/MyIcons'

const SETTINGS_TAB_ICONS = {
    settingsUsersTab: 'peopleAltIcon',
    settingsOneJobPasswordsTab: 'passwordIcon',
    settingsDbManagementTab: 'dataUsageIcon',
    settingsTemplatesManagementTab: 'descriptionIcon',
    settingsIntegrationsTab: 'accountTreeIcon',
    settingsDevicesTab: 'graphicEqIcon',
    settingsJobConfigurationTab: 'menuBookIcon',
    settingsJobPlannerTab: 'jobPlannerIcon',
    settingsUnitSettingsTab: 'creditCardIcon',
    settingsUnitsTab: 'drillRigIcon',
    settingsFleetViewSettingsTab: 'settingsIcon',
    settingsApiKeysTab: 'apiKeyIcon',
}

const UserSettingsTabs = ({path}) => {

    const {tabs} = useUsersSettings()

    const { currentUser } = useAuth()
    const allowIntegration = useMemo(() => currentUser.allowUiIntegrations(), [currentUser])

    const renderTab = (navText, url = '', exact = false, id = '') => {
        const iconName = SETTINGS_TAB_ICONS[id]
        return (
            <li key={id || navText} className="asideNavItemHolder">
                <NavLink
                    className="asideNavItem"
                    activeClassName="active"
                    id={id}
                    to={`${path}/${url}`}
                    exact={exact}
                >
                    {iconName ? (
                        <span className="asideNavItemIcon" aria-hidden>
                            <MyIcons icon={iconName} fontSize="small" />
                        </span>
                    ) : null}
                    <span className="asideNavItemText">{navText}</span>
                </NavLink>
            </li>
        )
    }

    return (
        <ul className="asideNav">
            { tabs.map(({ label, title, path: tabPath, exact, id }) =>
                renderTab(title || label, tabPath, exact, id))}
        </ul>
    )
}

export default UserSettingsTabs
